<div class="content-wrapper">
  <div class="ev-sidebar">
    <app-ev-sidebar></app-ev-sidebar>
    <!-- Left Sidebar Panels -->
    <div [class.hidden]="activeOption !== SIDEBAR_MODES.CONTRIBUTE">
      <app-ev-contribute></app-ev-contribute>
    </div>
    <div [class.hidden]="activeOption !== SIDEBAR_MODES.LAYERS">
      <app-ev-layers></app-ev-layers>
    </div>
    <div [class.hidden]="activeOption !== SIDEBAR_MODES.SEARCH">
      <app-ev-search></app-ev-search>
    </div>
    <div [class.hidden]="activeOption !== SIDEBAR_MODES.FILTER">
      <app-ev-filter></app-ev-filter>
    </div>
    <div [class.hidden]="activeOption !== SIDEBAR_MODES.EXPORT">
      <app-ev-export></app-ev-export>
    </div>
    <div [class.hidden]="activeOption !== SIDEBAR_MODES.BASKET">
      <app-ev-basket></app-ev-basket>
    </div>
  </div>
  <div class="ev-map">
    <app-ev-map></app-ev-map>
  </div>
  <!-- Right Results Panel -->
  <div class="ev-sidebar" [class.hidden]="resultsPaneActive !== true">
    <app-ev-sidebar-results></app-ev-sidebar-results>
  </div>
</div>
